import { render } from "./RichEditor.vue?vue&type=template&id=df1a0a6c&scoped=true"
const script = {}

import "./RichEditor.vue?vue&type=style&index=0&id=df1a0a6c&lang=less&scoped=true"

import exportComponent from "E:\\wwwroot\\abz-shuzi\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df1a0a6c"]])

export default __exports__